import { gsap } from "gsap";

const initImageParallax = () => {
	const parallaxImages = document.querySelectorAll("[data-parallax]");

	parallaxImages.forEach((img) => {
		const speed = img.dataset.parallax || 0.5;
		const direction = img.dataset.parallaxDirection || "down";
		const yMovement = direction === "down" ? 100 : -100;

		gsap.set(img, {
			scale: 1.2,
			willChange: "transform",
			transformOrigin: "center center",
		});
		gsap.fromTo(
			img,
			{
				y: -yMovement * speed,
			},
			{
				y: yMovement * speed,
				ease: "none",
				scrollTrigger: {
					trigger: img.parentElement,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
				},
			}
		);
	});
};

export default initImageParallax;
